import { Icon } from '@iconify/react'
import { Link } from '@remix-run/react'
import {
	Badge,
	Button,
	Col,
	Container,
	Navbar,
	Nav,
	Row,
	Stack,
} from 'react-bootstrap'

const tags = [
	'Market Value',
	'Zambia',
	'Cars',
	'White Book Value',
	'Motor Evaluation',
	'Fast',
]

const socialLinks = [
	{
		icon: 'mdi:twitter',
		name: 'Twitter',
		href: '/',
	},
	{
		icon: 'mdi:facebook',
		name: 'Facebook',
		href: '/',
	},
	{
		icon: 'mdi:instagram',
		name: 'Instagram',
		href: '/',
	},
]

const quickLinks = [
	{
		name: 'Search',
		href: '/',
	},
	{
		name: 'About',
		href: '/',
	},
	{
		name: 'Contact',
		href: '/',
	},
	{
		name: 'Sign up',
		href: '/',
	},
]

export default function UIFooter() {
	return (
		<Navbar
			className="min-vh-5 w-100 px-4 bg-theme text-on-theme justify-content-between bottom-footer"
			// sticky="bottom"
			data-bs-theme="light"
		>
			<Container>
				<div className="justify-content-center text-center">
					<Navbar.Brand href="/dashboard">
						<strong>
							<span className="text-white">Easy</span>Cover
						</strong>
					</Navbar.Brand>
					<small>
						© 2023{' '}
						<a
							href="https://kiz.co.zm"
							className="creator-tag"
							target="_blank"
							rel="noreferrer"
						>
							Klapton Insurance Zambia
						</a>
					</small>
				</div>
				<div className="justify-content-end">
					<small>
						Powered by:{' '}
						<a
							href="https://kuala.io"
							className="creator-tag"
							target="_blank"
							rel="noreferrer"
						>
							Kuala Tech Ltd
						</a>
					</small>
				</div>
				{/* <Nav className="me-auto">
			<strong>Quick Links</strong>
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#features">Features</Nav.Link>
            <Nav.Link href="#pricing">Pricing</Nav.Link>
          </Nav> */}

				{/* <Row className="justify-content-between"> */}
				{/* <Col>
						<Navbar.Brand href="/dashboard">EasyCover</Navbar.Brand>
					</Col>
					<Col>
						<Row className="justify-content-between">
							<strong>Quick Links</strong>
							<Nav.Link href="#home">Home</Nav.Link>
							<Nav.Link href="#features">Features</Nav.Link>
							<Nav.Link href="#pricing">Pricing</Nav.Link>
						</Row>
					</Col>
				</Row> */}
			</Container>
		</Navbar>
		// <Container className="position-relative">
		// <Button
		// 	className="position-absolute bottom-100 end-0 rounded-circle mb-4 d-flex justify-content-center align-items-baseline"
		// 	variant="dark"
		// 	style={{
		// 		width: '3rem',
		// 		height: '3rem',
		// 	}}
		// >
		// 	<span style={{ height: '1rem', width: '1rem' }}>
		// 		<Icon
		// 			style={{
		// 				width: '1rem',
		// 				height: '1rem',
		// 			}}
		// 			icon="heroicons:arrow-up"
		// 			aria-hidden="true"
		// 		/>
		// 	</span>
		// </Button>
		// <Row>
		// 	<Col xs={4}>
		// 		<h2 className="h3">
		// 			<strong>@ Whitebook Value</strong>
		// 		</h2>
		// 		<p className="mt-4 text-secondary">
		// 			Zambia's first online public motor vehicle evaluator
		// 		</p>
		// 		<p className="mt-4 text-secondary">
		// 			&copy; Kuala Tech Ltd. All rights reserved.
		// 			<span className="d-block">
		// 				Terms of Service &bull; Privacy Policy
		// 			</span>
		// 		</p>
		// 	</Col>
		// 	<Col xs={2}>
		// 		<h3>
		// 			<strong>Tags</strong>
		// 		</h3>
		// 		{/*<Stack direction="horizontal" gap={1}>*/}
		// 		{tags.map((tag, idx) => (
		// 			<Badge
		// 				key={idx}
		// 				className="text-uppercase h6 bg-white me-1"
		// 				text="secondary"
		// 			>
		// 				{tag}
		// 			</Badge>
		// 		))}
		// 		{/*</Stack>*/}
		// 	</Col>
		// 	<Col xs={2}>
		// 		<h3>
		// 			<strong>Social</strong>
		// 		</h3>
		// 		{socialLinks.map((link, idx) => (
		// 			<Link
		// 				to={link.href}
		// 				key={idx}
		// 				className="d-block my-2 text-secondary text-decoration-none"
		// 			>
		// 				<Stack
		// 					direction="horizontal"
		// 					key={idx}
		// 					gap={1}
		// 					className="align-items-baseline"
		// 				>
		// 					<span
		// 						style={{
		// 							width: '1.25rem',
		// 							height: '1.25rem',
		// 						}}
		// 					>
		// 						<Icon
		// 							style={{ width: '1.25rem', height: '1.25rem' }}
		// 							icon={link.icon}
		// 							aria-hidden={true}
		// 						/>
		// 					</span>
		// 					<span>{link.name}</span>
		// 				</Stack>
		// 			</Link>
		// 		))}
		// 	</Col>
		// 	<Col xs={4}>
		// 		<h3>
		// 			<strong>Quick Links</strong>
		// 		</h3>
		// 		{quickLinks.map((link, idx) => (
		// 			<Link
		// 				to={link.href}
		// 				key={idx}
		// 				className="d-block my-2 text-secondary text-decoration-none"
		// 			>
		// 				{link.name}
		// 			</Link>
		// 		))}
		// 	</Col>
		// </Row>
		// </Container>
	)
}
